export const parcelData = [
    {
        "_id": {
            "$oid": "640fbdda049fca31202e0021"
        },
        "trackingNumber": "YT2300480731864",
        "user": "test@test.com",
        "isShipped": true,
        "isWeighted": true,
        "weight": 4.5,
        "created": "2023-03-14T00:20:42.245Z",
        "modified": "2023-03-16T07:23:27.523Z",
        "picture": "https://static.zara.net/photos///2023/V/0/1/p/2295/001/712/2/w/2156/2295001712_1_1_1.jpg?ts=1673528443027",
        "name": "Hoodie Sweatshirt",
        "courier": "yto",
        "shipGroup": {
            "$oid": "6411436c04c6777b3e65ca93"
        }
    },
    {
        "_id": {
            "$oid": "640fbde03a75069150370f71"
        },
        "trackingNumber": "YT2291820384610",
        "user": "test@test.com",
        "isShipped": true,
        "isWeighted": true,
        "weight": 5,
        "created": "2023-03-14T00:20:48.891Z",
        "modified": "2023-03-14T00:20:48.891Z",
        "name": "Contrasting Sweatshirt",
        "picture": "https://static.zara.net/photos///2023/V/0/1/p/1165/154/251/2/w/1024/1165154251_6_1_1.jpg?ts=1675272061978",
        "courier": "yto",
        "shipGroup": {
            "$oid": "6411436c04c6777b3e65ca93"
        }
    },{
        "_id": {
            "$oid": "640fbde63a75069150370f72"
        },
        "trackingNumber": "YT2298979475482",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": true,
        "weight": 1.5,
        "created": "2023-03-14T00:20:54.017Z",
        "modified": "2023-04-03T03:14:43.889Z",
        "name": "Zip Collar Sweatshirt",
        "picture": "https://static.zara.net/photos///2023/V/0/2/p/6462/350/251/2/w/1024/6462350251_1_1_1.jpg?ts=1675677581801",
        "courier": "yto"
    },{
        "_id": {
            "$oid": "640fc9351989c397f8ff56aa"
        },
        "trackingNumber": "433005993764573",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": true,
        "weight": 3.2,
        "created": "2023-03-14T01:09:09.013Z",
        "modified": "2023-04-03T03:30:56.577Z",
        "name": "Embroidered Collared Sweatshirt",
        "picture": "https://static.zara.net/photos///2023/V/0/2/p/3037/450/922/2/w/1024/3037450922_2_1_1.jpg?ts=1675874062806",
        "courier": "yunda"
    },{
        "_id": {
            "$oid": "6411083a69a248c7f8f6d12b"
        },
        "name": "Knit Polo Sweater",
        "trackingNumber": "YT6950106245135",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-03-14T23:50:18.618Z",
        "modified": "2023-03-14T23:50:18.618Z",
        "picture": "https://static.zara.net/photos///2023/V/0/1/p/6771/024/104/2/w/850/6771024104_6_1_1.jpg?ts=1674752008165"
    },{
        "_id": {
            "$oid": "6411091f69a248c7f8f6d12c"
        },
        "name": "Jollipop Puppy",
        "trackingNumber": "YT6984578701242",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": true,
        "isWeighted": true,
        "created": "2023-03-14T23:54:07.689Z",
        "modified": "2023-03-14T23:54:07.689Z",
        "picture": "https://www.jellycat.com/images/products/medium/JOL3PU.jpg",
        "weight": 1.7,
        "shipGroup": {
            "$oid": "64114c2104c6777b3e65ca94"
        }
    },{
        "_id": {
            "$oid": "64110bf8f2f933ee8063e373"
        },
        "name": "High Heels",
        "trackingNumber": "YT7092003376427",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": true,
        "isWeighted": true,
        "created": "2023-03-15T00:06:16.436Z",
        "modified": "2023-03-15T00:06:16.436Z",
        "shipGroup": {
            "$oid": "6411436c04c6777b3e65ca93"
        },
        "weight": 3.5,
        "picture": "https://static.zara.net/photos///2022/I/1/7/p/1400/150/800/2/w/1500/1400150800_6_1_1.jpg?ts=1667401581518"
    },{
        "_id": {
            "$oid": "641111fcf2f933ee8063e374"
        },
        "name": "Nail polish",
        "trackingNumber": "YT7099110887611",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-03-15T00:31:56.592Z",
        "modified": "2023-03-15T00:31:56.592Z",
        "picture": "https://cdnsc1.melaleuca.com/cdn-cgi/image/width=500height=500,quality=85/global/products/70042h-02-enus.png"
    },{
        "_id": {
            "$oid": "6411128869a248c7f8f6d12f"
        },
        "name": "Gift for cuichan",
        "trackingNumber": "YT7062562568002",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-03-15T00:34:16.475Z",
        "modified": "2023-03-15T00:34:16.475Z",
    },{
        "_id": {
            "$oid": "64111325f2f933ee8063e375"
        },
        "name": "Huddles Sheep",
        "trackingNumber": "433078065355620",
        "courier": "yunda",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-03-15T00:36:53.186Z",
        "modified": "2023-03-15T00:36:53.186Z",
        "picture": "https://www.jellycat.com/images/products/large/HUD2S.jpg"
    },{
        "_id": {
            "$oid": "6411137ef2f933ee8063e376"
        },
        "name": "Nesting Bunnies",
        "trackingNumber": "YT7062270070244",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-03-15T00:38:22.268Z",
        "modified": "2023-03-15T00:38:22.268Z",
        "picture": "https://www.jellycat.com/images/products/medium/NEST3B.jpg"
    },{
        "_id": {
            "$oid": "641113c669a248c7f8f6d131"
        },
        "name": "Yummy Duckling",
        "trackingNumber": "YT7060760225093",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": true,
        "created": "2023-03-15T00:39:34.867Z",
        "modified": "2023-04-03T06:10:01.571Z",
        "picture": "https://www.jellycat.com/images/products/medium/YUM6DK.jpg",
        "weight": 2.3
    },{
        "_id": {
            "$oid": "64111411f2f933ee8063e377"
        },
        "name": "Amuseable Birthday Cake",
        "trackingNumber": "YT7060367573853",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": true,
        "isWeighted": true,
        "created": "2023-03-15T00:40:49.901Z",
        "modified": "2023-03-15T00:40:49.901Z",
        "picture": "https://www.jellycat.com/images/products/medium/A2BC.jpg",
        "weight": 2.8,
        "shipGroup": {
            "$oid": "641143f6bd7c774187a11f06"
        }
    },{
        "_id": {
            "$oid": "641114edf2f933ee8063e378"
        },
        "name": "Peanut Penguin",
        "trackingNumber": "433098257144345",
        "courier": "yunda",
        "user": "test@test.com",
        "isShipped": true,
        "isWeighted": true,
        "created": "2023-03-15T00:44:29.368Z",
        "modified": "2023-03-15T00:44:29.368Z",
        "picture": "https://www.jellycat.com/images/products/medium/PNM3PN.jpg",
        "shipGroup": {
            "$oid": "64129c5a2d97dfd382bc4d57"
        },
        "weight": 3.9
    },{
        "_id": {
            "$oid": "6413b48e0c5ee1d68622cf43"
        },
        "name": "Cat Carrier",
        "trackingNumber": "433061274107582",
        "courier": "yunda",
        "user": "test@test.com",
        "picture": "https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcSNXME8KkDf10aw4S41c_6UpZfn1m-Xysweia4IBO9uYAeSf0QbwaF2mmcXRJlEIAkwc5vO89Ar",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-03-17T00:30:06.271Z",
        "modified": "2023-03-17T00:30:06.271Z",
    },{
        "_id": {
            "$oid": "6414f5a837d1dbabfbd1516b"
        },
        "name": "Jellycat",
        "trackingNumber": "433092079116724",
        "courier": "yunda",
        "user": "test@test.com",
        "picture": "https://res.cloudinary.com/dub3oxwts/image/upload/18c9033a4ef84aa7b559b2a9fad9d7c8",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-03-17T23:20:08.098Z",
        "modified": "2023-03-17T23:20:08.098Z",
    },{
        "_id": {
            "$oid": "642901f20938edd3f5e70b62"
        },
        "name": "Clothes",
        "trackingNumber": "462843764009661",
        "courier": "yunda",
        "user": "unittest@unittest.com",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-04-02T04:17:54.154Z",
        "modified": "2023-04-02T04:17:54.154Z",
    },{
        "_id": {
            "$oid": "642914cf0938edd3f5e70b64"
        },
        "name": "Short Dress with Detail ",
        "trackingNumber": "YT7144862930287",
        "courier": "yto",
        "user": "test@test.com",
        "picture": "https://static.zara.net/photos///2023/V/0/7/p/9000/900/800/2/w/1500/9000900800_6_1_1.jpg?ts=1675857107297",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-04-02T05:38:23.183Z",
        "modified": "2023-04-02T05:38:23.183Z",
    },{
        "_id": {
            "$oid": "64291534cb820ee99e5da51c"
        },
        "name": "food",
        "trackingNumber": "YT7130484733722",
        "courier": "yto",
        "user": "unittest@unittest.com",
        "picture": "https://res.cloudinary.com/dub3oxwts/image/upload/580880cbca604b429bb65e6620e0639c",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-04-02T05:40:04.974Z",
        "modified": "2023-04-02T05:40:04.974Z",
    },{
        "_id": {
            "$oid": "642915edcb820ee99e5da51d"
        },
        "name": "Dress",
        "trackingNumber": "YT7136320603122",
        "courier": "yto",
        "user": "test@test.com",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-04-02T05:43:09.766Z",
        "modified": "2023-04-02T05:43:09.766Z",
    },{
        "_id": {
            "$oid": "6429ea49d9cee35dbdc12d8e"
        },
        "name": "JK accessories ",
        "trackingNumber": "YT7134810597159",
        "courier": "yto",
        "user": "www@mail.com",
        "picture": "https://res.cloudinary.com/dub3oxwts/image/upload/c85fc409921b43028698b5ea3fa16db3",
        "isShipped": false,
        "isWeighted": false,
        "created": "2023-04-02T20:49:13.442Z",
        "modified": "2023-04-02T20:49:13.442Z",
    }];

